import React, { useState } from "react";
import SideBar from "../components/SideBar";
import NavBar from "../components/NavBar";
import HelloSection from "../components/HelloSection";
import Work from "../components/Work";
import About from "../components/About";
import Gallery from "../components/Gallery";
import Footer from "../components/Footer";

const Home = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };
    return (
        <>
            <SideBar isOpen={isOpen} toggle={toggle} />
            <NavBar toggle={toggle} />
            <HelloSection />
            <Work />
            <Gallery />
            <About />
            <Footer />
        </>
    );
};

export default Home;
